<template>
  <span
    v-if="canAccessGit"
    class="owal git info"
    @dblclick="showFull = !showFull"
  >
    {{ this.gitInfo }}
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import { Service, Operation } from '@/libraries/permissions'

export default {
  name: 'GithubInfo',
  data () {
    return {
      showFull: false,
    }
  },
  computed: {
    ...mapGetters({
      canPerformOperationForService: 'entitlements/canPerformOperationForService',
    }),
    canAccessGit () {
      const explicitGitPermission = this.canPerformOperationForService(Service.STAFF, Operation.VIEW_GIT_INFO)
      // TODO: Verify how "all" entitlements work.
      const generalStaffAccess = this.canPerformOperationForService(Service.STAFF, Operation.VIEW_INTERNAL_LINKS)
      return explicitGitPermission || generalStaffAccess
    },
    branch: function () {
      return process.env.VUE_APP_OWAL_GIT_CURRENT_BRANCH
    },
    commitShort: function () {
      return process.env.VUE_APP_OWAL_GIT_CURRENT_REV_SHORT
    },
    commitFull: function () {
      return process.env.VUE_APP_OWAL_GIT_CURRENT_REV_FULL
    },
    tag: function () {
      return process.env.VUE_APP_OWAL_GIT_CURRENT_TAG
    },
    gitInfo: function () {
      const commit = this.showFull ? this.commitFull : this.commitShort

      if (!commit) {
        return 'no git information.'
      }

      const branch = this.branch
      const tag = this.tag
      let info = `${branch}/${commit} (${tag})`

      if (!tag || tag === 'undefined') {
        info = `${this.branch}/${commit}`
      }

      return info
    },
  },
}
</script>

<style scoped>
.owal.git.info {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  padding: 0.3125rem;
  background: #d6d6d6;
  color: #6d6d6d;
  padding: 0.5rem;
  border-radius: 0.5rem;
  z-index: 999;
  opacity: 0.2;
  transition: all 0.3s ease-in;
}

.owal.git.info:hover {
  opacity: 1;
}
</style>
